<template>
    <div v-if="loading" class="loading-spinner-type-1 primary"></div>
    <CustomCheckbox
        v-else-if="hasLists"
        :modelValue="modelValue"
        :inputKey="inputKey"
        @update:modelValue="onChanged"
        :options="options"
        cssClass="custom-checkbox-type-5"
        :showLabel="showLabel"
        :showDescription="showDescription"
    />
    <div v-else-if="$te(`fields.${inputKey}.no_results`)" class="p no-results">{{$t(`fields.${inputKey}.no_results`)}}</div>
</template>

<script>
    import { mapState, mapActions } from 'pinia';
    import { useAudiencesStore } from '@/stores/audiences';
    import CustomCheckbox from '@/components/inputs/CustomCheckbox';

    export default {
        name: "CustomCheckboxLists",
        props: {
            modelValue: {
                type: Array,
                default: () => []
            },
            showLabel: {
                type: Boolean,
                default: true,
            },
            showDescription: {
                type: Boolean,
                default: false
            },
            inputKey: {
                type: String,
                default: 'prospects_filter_lists'
            }
        },
        data() {
            return {
                loading: false
            };
        },
        components: {
            CustomCheckbox
        },
        computed: {
            ...mapState(useAudiencesStore, ['audiences']),
            hasLists() {
                return this.audiences && this.audiences.length > 0;
            },
            options() {
                var result = this.audiences.map(audience => ({
                    noTranslate: true,
                    value: audience.qid || null,
                    text: audience.name || null
                }));
                return result.filter(audience => audience.value !== null && audience.text !== null);
            }
        },
        methods: {
            ...mapActions(useAudiencesStore, ['getAudiences']),
            onChanged(newValue) {
                this.$emit('update:modelValue', newValue);
            },
        },
        async mounted() {
            this.loading = true;
            await this.getAudiences();
            this.loading = false;
        }
    }
</script>